export const STORAGE_CONSTANTS = {
  AUTH_TOKEN: 'authToken',
  REFRESH_TOKEN: 'refreshToken',
  MQTT_CREDENTIALS_STORAGE_KEY: 'mqtt_credentials',
} as const;

export const PORTFOLIO_CONSTANTS = {
  PORTFOLIOS_GRID_VIEW_LIMIT: 15,
  UNITS_GRID_VIEW_LIMIT: 15,
} as const;

export const REGEX = {
  EMAIL: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$',
  DROPLET: '^([0-9A-Fa-f]{2}){5}([0-9A-Fa-f]{2})$',
} as const;

export const DEFAULT_TITLE = 'Stormcloud';

export const TOTAL_COL = 12;

export const MAX_WIDTH_WIDE = 1400;

export const SYSTEM_STATUS_REFRESH_TIME_SEC = 10 * 1000; // 10 seconds

export enum DropletItemMode {
  DEVICE = 1,
  CONTROLLER = 2,
}

export enum ModalIdentifier {
  UNKNOWN = 1,
  DEVICE_DETAILS,
  CONTROLLER_ADD,
  CONTROLLER_DETAILS,
  PORTFOLIO_CREATE,
  PORTFOLIO_EDIT,
  UNIT_CREATE,
}

export enum States {
  INITIAL_LOADING,
  INITIAL_DATA_RECEIVED,
  INITIAL_ERROR,
  REQUEST_IN_PROCESS,
  REQUEST_SUCCESS,
  REQUEST_ERROR,
}

export enum SkeletonPlaceholder {
  UNKNOWN = 1,
  CARD,
  TABLE_HEADER_FOUR_COLUMN,
  SINGLE_ROW,
  TABLE_WITH_HEADER_AND_FOOTER,
  TABLE_WITH_HEADER,
  WIDGET,
  CARD_WITH_COLUMN_AND_ROW,
}
